import type { LookupServiceResponseType, QrzLookupResponseType } from "@/types";
import { ProviderCallsignNotFoundError } from "@/utils/errors/LookupServiceErrors";
import { handleQrzError } from "@/utils/errors/QrzErrorHandler";
import { toNumber } from "@/utils/coerce";

export default function QrzResponseToLogbookResponseTransformer(
  response: QrzLookupResponseType
): LookupServiceResponseType {
  if (!response) {
    throw new Error("QRZ response is undefined");
  }

  if (!response.QRZDatabase) {
    throw new Error("Invalid QRZ response format: missing QRZDatabase");
  }

  // Check for QRZ error messages in the Session
  if (response.QRZDatabase.Session?.Error) {
    handleQrzError("QRZ", response.QRZDatabase.Session.Error);
  }

  if (!response.QRZDatabase.Callsign) {
    throw new ProviderCallsignNotFoundError("QRZ", "No callsign data found in QRZ response");
  }

  const lookup = response.QRZDatabase.Callsign;
  return {
    provider: "QRZ",
    callsign: lookup?.call ?? "",
    fullName: lookup?.name_fmt ?? `${lookup?.fname ?? ""} ${lookup?.name ?? ""}`,
    firstName: lookup?.fname ?? "",
    lastName: lookup?.name ?? "",
    address1: lookup?.addr1 ?? "",
    address2: "",
    city: lookup?.addr2 ?? "",
    state: lookup?.state ?? "",
    zip: lookup?.zip ?? "",
    country: lookup?.country,
    gridsquare: lookup?.grid,
    latitude: toNumber(lookup?.lat),
    longitude: toNumber(lookup?.lon),
    ituZone: toNumber(lookup?.ituzone),
    cqZone: toNumber(lookup?.cqzone),
    county: lookup?.county ?? "",
    class: lookup?.class,
    continent: undefined,
    dxcc: toNumber(lookup?.dxcc),
    email: lookup?.email || "",
  };
}
